// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-up.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-up',
  version: 'outline',
  paths: [
    {
      d: 'M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18',
    },
  ],
}
